var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{attrs:{"title":"项目阶段进度"}}),(_vm.phaseList.length > 0)?_c('div',{staticClass:"wrapper"},_vm._l((_vm.phaseList),function(item,index){return _c('Progress',{key:index,attrs:{"phase":item},on:{"refresh":function($event){return _vm.$emit('refresh')}}})}),1):_c('div',{staticClass:"wrapper"},[_c('a-empty')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }